/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisclaimerItemDto
 */
export interface DisclaimerItemDto {
    /**
     * 
     * @type {string}
     * @memberof DisclaimerItemDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof DisclaimerItemDto
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof DisclaimerItemDto
     */
    text: string;
}

/**
 * Check if a given object implements the DisclaimerItemDto interface.
 */
export function instanceOfDisclaimerItemDto(value: object): value is DisclaimerItemDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function DisclaimerItemDtoFromJSON(json: any): DisclaimerItemDto {
    return DisclaimerItemDtoFromJSONTyped(json, false);
}

export function DisclaimerItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisclaimerItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'language': json['language'],
        'text': json['text'],
    };
}

export function DisclaimerItemDtoToJSON(json: any): DisclaimerItemDto {
    return DisclaimerItemDtoToJSONTyped(json, false);
}

export function DisclaimerItemDtoToJSONTyped(value?: DisclaimerItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'language': value['language'],
        'text': value['text'],
    };
}

